  var ButtonModalPopup = (function () {
    var config = {
        modalVideoSelector: ".modal-video",
        bodyVideoClass: "has-videocontainer",
        modalEventShown: "shown.bs.modal",
        modalEventHidden: "hidden.bs.modal",
        youTubeVideoSelector: null,
        html5VideoSelector: null,
        resizeTimeout: null,
    };

    function ButtonModalPopup() {
        //method intentionally left empty
    }

    ButtonModalPopup.prototype.init = function () {
        var self = this;

        // Add class to body if .videocontainer exists
        if ($(config.modalVideoSelector).length > 0) {
            $("body").addClass(config.bodyVideoClass);
        }

        self.bindEvents();
        self.autoplayVideosOnLoad();
    };

    ButtonModalPopup.prototype.bindEvents = function () {
        var self = this;

        // Bind events for modals
        $(config.modalVideoSelector).on(config.modalEventShown, function (e) {
            self.onModalShown(e);
        });

        $(config.modalVideoSelector).on(config.modalEventHidden, function (e) {
            self.onModalHidden(e);
        });

        // Bind events for window resize
        $(window).on("resize", function () {
            //clear timeout
            clearTimeout(config.resizeTimeout);

            //set timeout
            config.resizeTimeout = setTimeout(function () {
                self.setYouTubeWidthAndHeight();
                self.setHtml5VideoWidthAndHeight();
            }, 400);
        });
    };

    ButtonModalPopup.prototype.onModalShown = function (e) {
        var self = this;
        var modal = $(e.target);
        var video = modal.find("video");
        var iframe = modal.find("iframe");
        if (video.length > 0) {
            video[0].play();
            self.html5VideoSelector = video;
            self.setHtml5VideoWidthAndHeight();
        } else if (iframe.length > 0) {
            self.youTubeVideoSelector = iframe;
            self.setYouTubeWidthAndHeight();
        }
    };

    ButtonModalPopup.prototype.setHtml5VideoWidthAndHeight = function () {
        var self = this;
        if (!self.html5VideoSelector) {
            return;
        }

        self.setVideoDimensions(self.html5VideoSelector);
    };

    ButtonModalPopup.prototype.setYouTubeWidthAndHeight = function () {
        var self = this;
        if (!self.youTubeVideoSelector) {
            return;
        }

        self.setVideoDimensions(self.youTubeVideoSelector);
    };

    ButtonModalPopup.prototype.setVideoDimensions = function (element) {
        var windowWidth = $(window).width() - 40;
        var windowHeight = $(window).height() - 110;
        var aspectRatio = 16 / 9;
        var newWidth = windowWidth;
        var newHeight = windowWidth / aspectRatio;

        if (newHeight > windowHeight) {
            newHeight = windowHeight;
            newWidth = windowHeight * aspectRatio;
        }

        element.css({
            width: newWidth,
            height: newHeight
        });
    };

    ButtonModalPopup.prototype.onModalHidden = function (e) {
        this.stopVideoAndIframe(e);
    };

    ButtonModalPopup.prototype.stopVideoAndIframe = function (e) {
        var modal = $(e.target);
        var video = modal.find("video");
        var iframe = modal.find("iframe");

        if (video.length > 0) {
            video[0].pause();
            video[0].currentTime = 0;
        } else if (iframe.length > 0) {
            var youtubeSrc = $(iframe).attr("src");
            $(iframe).attr("src", "");
            $(iframe).attr("src", youtubeSrc);
            self.youTubeVideoSelector = null;
        }
    };

    ButtonModalPopup.prototype.autoplayVideosOnLoad = function () {
        // Autoplay videos with autoplay attribute on page load
        $("video[autoplay]").each(function () {
            this.play();
        });
    };

    return ButtonModalPopup;
})();

(function ($) {
    $('body')
        .on('show.bs.modal', '.modal', onModalShow)
        .on('hide.bs.modal', onModalHide)
    var focusElement;
    function onModalShow(e) {
        $(".body-wrapper").attr("aria-hidden", "true");
        focusElement = document.activeElement;
        var modal = $(e.target);
        for (var i = 0; i < $('.modal.fade').length; i++) {
            if (focusElement.dataset.target !== modal.attr('id')) {
                var ele = $('.modal.fade')[i];
                ele.setAttribute("aria-hidden", "true");
            } else {
                var ele1 = $('.modal.fade.show')[i];
                ele1.setAttribute("aria-hidden", "false");
            }
        }
        if (!modal.is('[data-suppress-move="true"]')) {
            ensureModalIsFormChild(modal);
        }
    }
    function onModalHide(e) {
        if (!$(document.activeElement).parents().hasClass('modal-dialog')) {
            attachEventHandler("modalOutsideClick", "backdropClick", true);
        }
        $(".body-wrapper").attr("aria-hidden", "false");
        for (var i = 0; i < $('.modal.fade').length; i++) {
            var ele = $('.modal.fade')[i];
            ele.setAttribute("aria-hidden", "false");
        }
        setTimeout(function () { focusElement.focus(); }, 1000);
        var iframeSrc = $(e.target).siblings();
        var iframeEle = $(iframeSrc).children('iframe');
        if ($(iframeEle).attr('allow') === 'autoplay') {
            $(iframeEle).attr('src', '');
        } else {
            $(iframeEle).attr('src', $(iframeSrc).children('iframe').attr('src'));
        }
    }
    function ensureModalIsFormChild(modal) {
        if (!modal.parent().is('body')) modal.appendTo('body');
    }
}(window.jQuery));

// Initialize the class when the document is ready
$(document).ready(function () {
    if ($(".modal-video").length > 0) {
        new ButtonModalPopup().init();
    }

    $(".cta-button-popup-modal").on('click', function() {
       const backdrop = document.querySelectorAll(".modal-backdrop.fade.show");

        if(backdrop && backdrop.length > 1) {
            backdrop[0].remove();
        }
    });
});